import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { StyledButton, LoginWrapper, LoginBox, Logo, FieldWrapper, FieldLabel, StyledInput, ErrorText } from "./styled";
import { loginRequest, getCurrentUser } from "../api/auth";
import { useUser } from "../components/UserContext"; 

const Login: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const { setUser } = useUser(); 

  useEffect(() => {
    if (localStorage.getItem("access_token")) {
      navigate("/chat", { state: { justLoggedIn: true } });
    }
  }, [navigate]);

  const handleLogin = async () => {
    try {
      const token = await loginRequest(username, password);
      localStorage.setItem("access_token", token);
      const user = await getCurrentUser();
      setUser(user); 
      navigate("/chat");
    } catch (err) {
      console.error(err);
      setError("Invalid username or password");
    }
  };
  

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <LoginWrapper>
      <LoginBox>
        <Logo src="/logo.png" alt="Logo" />
        {error && <ErrorText variant="body1">{error}</ErrorText>}

        <FieldWrapper>
          <FieldLabel htmlFor="username">USERNAME</FieldLabel>
          <StyledInput
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={handleKeyPress} 
            autoComplete="off"
          />
        </FieldWrapper>

        <FieldWrapper>
          <FieldLabel htmlFor="password">PASSWORD</FieldLabel>
          <StyledInput
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyPress} 
            autoComplete="off"
          />
        </FieldWrapper>

        <StyledButton variant="contained" onClick={handleLogin}>
          LOGIN
        </StyledButton>
      </LoginBox>
    </LoginWrapper>
  );
};

export default Login;
